// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dam-6"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 3H20V21H15V15C15 13.3431 13.6569 12 12 12V12C10.3431 12 9 13.3431 9 15V21H4V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 21H3M4 21H9M4 21V3H20V21M20 21H21M20 21H15M9 21H10M9 21V15C9 13.3431 10.3431 12 12 12V12C13.6569 12 15 13.3431 15 15V21M14 21H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M3 8H4H9H15H20H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Dam6Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-6',
    ref,
    icon: element,
  },
));

Dam6Icon.displayName = 'Dam6Icon';

export default Dam6Icon;
